import { Link } from "react-router-dom";
import { Logo } from "./Logo";

// Shared public header (legal pages, /help, homepage).
export default function PublicHeader({ compactOnMobile = false }) {
  const linkCls = `hover:text-neutral-900 ${compactOnMobile ? "hidden sm:inline" : ""}`;
  return (
    <header className="border-b border-neutral-200 px-6 py-4 flex items-center justify-between bg-white"
            data-testid="public-header">
      <Link to="/" className="flex items-center" data-testid="legal-logo">
        <Logo testid="header-logo-img" />
      </Link>
      <nav className="flex items-center gap-4 text-xs uppercase tracking-widest">
        <Link to="/terms" className={linkCls}>Terms</Link>
        <Link to="/privacy" className={linkCls}>Privacy</Link>
        <Link to="/contact" className={linkCls}>Contact</Link>
        <Link to="/login" className="btn-primary ml-2 normal-case" data-testid="header-sign-in">Sign in</Link>
      </nav>
    </header>
  );
}
